import { atom } from "jotai";

export const authAtom = atom({
    isAuth: false,
    access_token: null,
    refresh_token: null,
});
